module.exports = __webpack_public_path__ + "img/1F9EF.c0195d11.svg";